import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceImportsStore = defineStore('deviceImports', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getDeviceImports: (state) => state.data?.data,
  },
  actions: {
    async indexDeviceImports(params = {}) {
      try {
        const response = await axios.get('device-imports', {params} );
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createDeviceImport(params = {}) {
      try {
        const response = await axios.get('device-imports/create', {params} );
        return useCreateForm('device-imports', response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDeviceImport( deviceImportId, params = {}) {
      try {
        const response = await axios.get(`device-imports/${deviceImportId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
